export interface PostListRes {
  data: Datum[];
  message: string;
  status: number;
}

export interface Datum {
  id: number;
  title: string;
  view_period: string;
  location: string;
  date: Date;
  summary: string;
  is_published: boolean;
  is_featured: boolean;
  type: Type;
  created_at: Date;
  updated_at: Date;
  is_deleted: boolean;
  main_audio_id: number | null;
  banner_id: number | null;
  main_video_id: number | null;
  user_id: number;
}

export enum Type {
  DigitalReport = 'DIGITAL_REPORT',
  Documentary = 'DOCUMENTARY',
  Podcast = 'PODCAST',
  Program = 'PROGRAM',
  Video = 'VIDEO',
}
